export function waitForImages(containerElement: HTMLElement): Promise<void> {
    const images = Array.from(containerElement.querySelectorAll('img'));

    if (images.length === 0) {
        return Promise.resolve();
    }

    const imagePromises = images.map((image) => {
        return new Promise<void>((resolve) => {
            if (image.complete) {
                resolve();
                return;
            }

            const handleLoadComplete = () => {
                image.removeEventListener('load', handleLoadComplete);
                image.removeEventListener('error', handleLoadComplete);
                resolve();
            };

            image.addEventListener('load', handleLoadComplete);
            image.addEventListener('error', handleLoadComplete);
        });
    });

    return Promise.all(imagePromises).then(() => { });
}